<ng-container *ngIf="variant">
    <div class="row" *ngIf="mobileView">
        <div class="col-12 d-flex justify-content-between align-items-center p-0">
            <div class="icon-button" (click)="onPreviousPosition()" mdbRipple>
                <i class="fas fa-arrow-left"></i>
            </div>
            <div class="w-100 d-flex justify-content-center gap-1 align-items-center">
                <span>{{position | titlecase}} Position</span>
                <div class="icon-button" (click)="onAddNote()" mdbRipple>
                    <i class="fas fa-note-sticky"></i>
                </div>
            </div>
            <div class="icon-button" (click)="onNextPosition()" mdbRipple>
                <i class="fas fa-arrow-right"></i>
            </div>
        </div>
    </div>
    <ng-container *ngIf="activePosition$ | async as pos">
        <div class="d-lg-flex flex-sm-column justify-content-lg-center h-100 overflow-hidden align-items-center">
            <div class="pd-design-tool-container text-center overflow" id="mockup-container" (drop)="onDrop($event)" #mockupContainer>
                <canvas id="fabricCanvas"></canvas>
                <img *ngIf="designMockups?.[pos] else notAvailable" crossorigin="anonymous" [src]="designMockups?.[pos]"
                    id="product-image" class="design-tool-image" loading="lazy" alt="Design Tool Image" #productImage (load)="onLoadProductImage()" (resize)="onProductImageResize($event)"/>
                <button type="button" class="btn btn-primary btn-floating d-lg-none d-sm-block position-absolute" mdbRipple style="bottom: 10px; right: 0px; z-index: 1;" (click)="onOpenDownloadOptions()">
                    <i class="fas fa-download"></i>
                </button>
                <button type="button" class="btn btn-success btn-floating d-lg-none d-sm-block position-absolute" mdbRipple style="bottom: 60px; right: 0px; z-index: 1;" (click)="onOpenLibrary()">
                    <i class="fas fa-image"></i>
                </button>
            </div>
            <div class="pd-tool-footer d-none align-items-center justify-content-between d-lg-flex" mdbDropdown *ngIf="canCustomize">
                <div>
                    <button type="button" class="btn btn-rounded btn-sm filter-pills pd-tool-style-btn" mdbRipple
                        rippleColor="dark" [cpPresetLabel]="colorPickerLabel" [cpPresetColors]="colorPickerColors"
                        [(colorPicker)]="colorPickerFirstColor">
                        Colors ({{colorPickerColors.length}})
                        <i class="fas fa-chevron-down"></i>
                    </button>
                    <button type="button" class="btn btn-rounded btn-sm filter-pills pd-tool-style-btn" type="button"
                        id="decorationType" aria-expanded="false" mdbDropdownToggle mdbRipple rippleColor="dark">
                        Type: {{selectedDecorationType}}
                        <i class="fas fa-chevron-down"></i>
                    </button>
                </div>
                <ul mdbDropdownMenu class="dropdown-menu" aria-labelledby="decorationType">
                    <li *ngFor="let type of types"><a class="dropdown-item"
                            (click)="selectDecorationType(type)">{{type}}</a></li>
                </ul>
                <div class="d-flex justify-content-end gap-2">
                    <button class="btn btn-rounded btn-info btn-sm download-btn pd-tool-style-btn" type="button"
                        (click)="exportProductMockup()">Download Product Mockup <i class="fas fa-download"></i></button>
                    <button class="btn btn-rounded btn-info btn-sm download-btn pd-tool-style-btn" type="button"
                        (click)="exportArtMockup(pos)">Download Art Mockup <i class="fas fa-download"></i>
                    </button>
                </div>
            </div>
        </div>
    </ng-container>
</ng-container>
<ng-template #notAvailable>
    <div class="h-100 d-flex align-items-center justify-content-center">This position is not available at this time.
    </div>
</ng-template>